import React, { useEffect, useState, useRef } from "react";
import rocketImage from "./rocket.svg";
import aestroid1 from "./aestroid1.svg";
import aestroid2 from "./aestroid2.svg";
import aestroid3 from "./aestroid3.svg";
import aestroid4 from "./aestroid4.svg";
import Popup from "../Popup";
import GameOverScreen from "../GameOverScreen";
import { updateDocumentInSubcollection } from "../../firestore_sub";
import { auth } from "../../firebase";
import { updateDocument, getDocument } from "../../firestore";
import { MdOutlineRestartAlt } from "react-icons/md";

function Game() {
  const [meteors, setMeteors] = useState([]);
  const [bullets, setBullets] = useState([]);
  const [score, setScore] = useState(0);
  const [meteorSpeed, setMeteorSpeed] = useState(2);
  const [meteorSpawnRate, setMeteorSpawnRate] = useState(2000);
  const [lives, setLives] = useState(3);
  const [gameOver, setGameOver] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const rocketPosition = useRef({ x: 400, y: 500 });
  const rocketDirection = useRef({ left: false, right: false });
  const canvasRef = useRef(null);
  const animationFrameRef = useRef(null);
  const stars = useRef([]);
  const backgroundOffset = useRef(0);
  const gameContainerRef = useRef(null);
  const collidedMeteorIds = useRef(new Set());

  const images = useRef({
    rocket: new Image(),
    aestroid1: new Image(),
    aestroid2: new Image(),
    aestroid3: new Image(),
    aestroid4: new Image(),
  });

  useEffect(() => {
    images.current.rocket.src = rocketImage;
    images.current.aestroid1.src = aestroid1;
    images.current.aestroid2.src = aestroid2;
    images.current.aestroid3.src = aestroid3;
    images.current.aestroid4.src = aestroid4;
  }, []);

  const uid = auth.currentUser ? auth.currentUser.uid : null;
  const rocket = {
    width: 70,
    height: 100,
    speed: 10,
  };

  // Generate stars for the background
  useEffect(() => {
    const generateStars = () => {
      const newStars = [];
      for (let i = 0; i < 100; i++) {
        newStars.push({
          x: Math.random() * 800,
          y: Math.random() * 600,
          size: Math.random() * 2 + 1,
          opacity: Math.random(),
        });
      }
      stars.current = newStars;
    };
    generateStars();
  }, []);

  // Draw stars on the canvas
  const drawStars = (ctx) => {
    stars.current.forEach((star) => {
      ctx.beginPath();
      ctx.arc(star.x, star.y, star.size, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(255, 255, 255, ${star.opacity})`;
      ctx.fill();
    });
  };

  // Update stars for blinking effect
  const updateStars = () => {
    stars.current = stars.current.map((star) => ({
      ...star,
      opacity: Math.random(), // Randomize opacity for blinking effect
    }));
  };

  // Move background downward
  const moveBackground = () => {
    backgroundOffset.current += 1; // Adjust speed as needed
    if (backgroundOffset.current > 600) {
      backgroundOffset.current = 0;
    }
  };

  useEffect(() => {
    if (score % 100 === 0 && score > 0) {
      setMeteorSpeed((prevSpeed) => Math.min(prevSpeed + 0.5, 10));
      setMeteorSpawnRate((prevRate) => Math.max(prevRate - 100, 500));
    }
  }, [score]);

  useEffect(() => {
    const spawnInterval = setInterval(() => {
      if (!isPaused && !gameOver) spawnMeteor();
    }, meteorSpawnRate);

    return () => clearInterval(spawnInterval);
  }, [meteorSpawnRate, isPaused, gameOver]);

  const spawnMeteor = () => {
    const x = Math.random() * 750;
    const meteor = {
      id: Date.now() + Math.random().toString(36).substr(2, 9), // Unique ID
      x,
      y: -100,
      width: 50,
      height: 50,
      speed: meteorSpeed,
      image: `aestroid${Math.floor(Math.random() * 4) + 1}`, // Randomly select an asteroid image
      hasCollided: false,
    };
    setMeteors((meteors) => [...meteors, meteor]);
  };

  const handleKeyDown = (event) => {
    if (event.key === "ArrowLeft") {
      rocketDirection.current.left = true;
    }
    if (event.key === "ArrowRight") {
      rocketDirection.current.right = true;
    }
    if (event.key === " ") {
      event.preventDefault();
      shootBullet();
    }
  };

  const handleKeyUp = (event) => {
    if (event.key === "ArrowLeft") {
      rocketDirection.current.left = false;
    }
    if (event.key === "ArrowRight") {
      rocketDirection.current.right = false;
    }
  };

  const moveRocket = () => {
    let newX = rocketPosition.current.x;
    if (rocketDirection.current.left && newX > 0) {
      newX -= rocket.speed;
    }
    if (rocketDirection.current.right && newX < 750) {
      newX += rocket.speed;
    }
    rocketPosition.current.x = newX;
  };

  const shootBullet = () => {
    setBullets((bullets) => [
      ...bullets,
      {
        x: rocketPosition.current.x + rocket.width / 2,
        y: rocketPosition.current.y,
        width: 5,
        height: 5,
      },
    ]);
  };

  const updateBullets = () => {
    setBullets((bullets) =>
      bullets
        .map((bullet) => ({ ...bullet, y: bullet.y - 10 }))
        .filter((bullet) => bullet.y > 0)
    );
  };

  const updateMeteors = () => {
    setMeteors((meteors) =>
      meteors.map((meteor) => ({ ...meteor, y: meteor.y + meteor.speed }))
    );
  };

  // const checkCollisions = () => {
  //   setMeteors((meteors) =>
  //     meteors.filter((meteor, index) => {
  //       console.log(meteor);
  //       if (meteor.y > 600) {
  //         setLives((lives) => lives - 1);
  //         return false;
  //       }

  //       if (
  //         meteor.x < rocketPosition.current.x + rocket.width &&
  //         meteor.x + meteor.width > rocketPosition.current.x &&
  //         meteor.y < rocketPosition.current.y + rocket.height &&
  //         meteor.y + meteor.height > rocketPosition.current.y
  //       ) {
  //         setLives((lives) => lives - 1);
  //         return false;
  //       }

  //       return true;
  //     })
  //   );

  //   bullets.forEach((bullet, bulletIndex) => {
  //     meteors.forEach((meteor, meteorIndex) => {
  //       if (
  //         bullet.x < meteor.x + meteor.width &&
  //         bullet.x + bullet.width > meteor.x &&
  //         bullet.y < meteor.y + meteor.height &&
  //         bullet.y + bullet.height > meteor.y
  //       ) {
  //         setScore((score) => score + 10);
  //         setMeteors((meteors) => meteors.filter((_, i) => i !== meteorIndex));
  //         setBullets((bullets) => bullets.filter((_, i) => i !== bulletIndex));
  //       }
  //     });
  //   });
  // };

  const checkCollisions = () => {
    // First process meteor collisions
    setMeteors((prevMeteors) => {
      const newMeteors = prevMeteors.filter((meteor) => {
        // Skip if already collided
        if (meteor.hasCollided) return false;

        const isOutOfBounds = meteor.y > 600;
        const hitsRocket =
          meteor.x < rocketPosition.current.x + rocket.width &&
          meteor.x + meteor.width > rocketPosition.current.x &&
          meteor.y < rocketPosition.current.y + rocket.height &&
          meteor.y + meteor.height > rocketPosition.current.y;

        if (isOutOfBounds || hitsRocket) {
          if (!collidedMeteorIds.current.has(meteor.id)) {
            // Correct syntax
            setLives((prev) => prev - 1);
            meteor.hasCollided = true;
            collidedMeteorIds.current.add(meteor.id); // Mark as collided
          }
          return false;
        }

        return true;
      });

      return newMeteors;
    });

    // Then process bullet collisions
    setBullets((prevBullets) => {
      return prevBullets.filter((bullet) => {
        const meteorIndex = meteors.findIndex(
          (meteor) =>
            !meteor.hasCollided &&
            bullet.x < meteor.x + meteor.width &&
            bullet.x + bullet.width > meteor.x &&
            bullet.y < meteor.y + meteor.height &&
            bullet.y + bullet.height > meteor.y
        );

        if (meteorIndex !== -1) {
          setScore((prev) => prev + 10);
          setMeteors((prev) =>
            prev
              .map((m, i) =>
                i === meteorIndex ? { ...m, hasCollided: true } : m
              )
              .filter((m) => !m.hasCollided)
          );
          return false;
        }
        return true;
      });
    });
  };

  useEffect(() => {
    if (lives <= 0) {
      gameOverDBUpdate();
      setGameOver(true);
      setIsPaused(true);
    }
  }, [lives]);

  async function gameOverDBUpdate() {
    const queryParams = new URLSearchParams(window.location.search);
    const gameId = queryParams.get("id");
    const userId = auth.currentUser.uid;
    const subCollectionPath = `gameplay/${userId}/gameplays/`;
    const gameplayData = { lives: 0, score };
    await updateDocument(subCollectionPath, gameId, gameplayData);
    await totalGameDataUpdate(score);
  }

  async function totalGameDataUpdate(score) {
    const subCollectionPath = `gameplay`;
    const userId = auth.currentUser.uid;
    const docData = await getDocument(subCollectionPath, userId);
    const oldScore = docData.score;
    const total_games = docData.games_played + 1;
    const currentScore = score + oldScore;
    const gameplayData = { games_played: total_games, score: currentScore };
    await updateDocument(subCollectionPath, userId, gameplayData);
  }

  const resetGame = () => {
    setGameOver(false);
    setIsPaused(false);
    setLives(3);
    setScore(0);
    setMeteors([]);
    setBullets([]);
    setMeteorSpeed(2);
    collidedMeteorIds.current.clear();
  };

  useEffect(() => {
    const newSpeed = 0.3 + Math.floor(score / 100);
    setMeteorSpeed(newSpeed);
  }, [score]);

  // const gameLoop = () => {
  //   if (!isPaused && !gameOver) {
  //     updateMeteors();
  //     updateBullets();
  //     checkCollisions();
  //     moveRocket();
  //     updateStars();
  //     moveBackground();

  //     const canvas = canvasRef.current;
  //     const ctx = canvas.getContext("2d");

  //     // Clear the canvas
  //     ctx.clearRect(0, 0, canvas.width, canvas.height);

  //     // Draw stars
  //     drawStars(ctx);

  //     // Draw meteors
  //     meteors.forEach((meteor) => {
  //       const image = images.current[meteor.image];
  //       ctx.drawImage(image, meteor.x, meteor.y, meteor.width, meteor.height);
  //     });

  //     // Draw bullets
  //     bullets.forEach((bullet) => {
  //       ctx.beginPath();
  //       ctx.arc(bullet.x, bullet.y, bullet.width, 0, Math.PI * 2);
  //       ctx.fillStyle = "yellow";
  //       ctx.fill();
  //     });

  //     // Draw rocket
  //     ctx.drawImage(
  //       images.current.rocket,
  //       rocketPosition.current.x,
  //       rocketPosition.current.y,
  //       rocket.width,
  //       rocket.height
  //     );

  //     animationFrameRef.current = requestAnimationFrame(gameLoop);
  //   }
  // };

  const gameLoop = () => {
    if (!isPaused && !gameOver) {
      // Update positions first
      moveRocket();
      updateStars();
      moveBackground();

      // Then update game objects
      setMeteors((prev) => prev.map((m) => ({ ...m, y: m.y + m.speed })));

      setBullets((prev) =>
        prev.map((b) => ({ ...b, y: b.y - 10 })).filter((b) => b.y > 0)
      );

      // Finally check collisions
      checkCollisions();

      // Render everything
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      drawStars(ctx);

      meteors.forEach((meteor) => {
        const image = images.current[meteor.image];
        ctx.drawImage(image, meteor.x, meteor.y, meteor.width, meteor.height);
      });

      bullets.forEach((bullet) => {
        ctx.beginPath();
        ctx.arc(bullet.x, bullet.y, bullet.width, 0, Math.PI * 2);
        ctx.fillStyle = "yellow";
        ctx.fill();
      });

      ctx.drawImage(
        images.current.rocket,
        rocketPosition.current.x,
        rocketPosition.current.y,
        rocket.width,
        rocket.height
      );

      animationFrameRef.current = requestAnimationFrame(gameLoop);
    }
  };

  useEffect(() => {
    animationFrameRef.current = requestAnimationFrame(gameLoop);

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);

    return () => {
      cancelAnimationFrame(animationFrameRef.current);
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, [meteors, bullets, rocketPosition, meteorSpeed, isPaused]);

  useEffect(() => {
    const popupInterval = setInterval(() => {
      setIsPaused(true);
      setShowPopup(true);
    }, 20000);

    return () => clearInterval(popupInterval);
  }, []);

  const handleClosePopup = () => {
    setShowPopup(false);
    setIsPaused(false);
  };

  const exitGame = () => {
    window.location.href = "/games";
  };

  const renderHearts = () => {
    return Array.from({ length: 3 }).map((_, index) => (
      <span
        key={index}
        className={`text-red-500 text-2xl ${
          index < lives ? "opacity-100" : "opacity-30"
        }`}
      >
        ❤️
      </span>
    ));
  };

  return (
    <div className="min-h-screen bg-[var(--background-color)] py-8 px-4 sm:px-6 lg:px-8 animate-fadeIn">
      <div className="max-w-7xl mx-auto">
        {/* Game Title with Gradient */}
        <h1 className="font-['Jersey_25',sans-serif] text-4xl md:text-5xl font-bold text-center mb-10 text-yellow-500 bg-gradient-to-r from-[var(--primary-color)] via-[var(--interactive-color)] to-[var(--accent-color)] text-transparent bg-clip-text transform transition-all">
          Meteor Shooter Game
        </h1>

        <div className="bg-[var(--surface-color)] rounded-2xl shadow-lg overflow-hidden border border-[var(--border-color)]">
          <div className="bg-[var(--primary-color)] py-4 px-6">
            <div className="flex items-center">
              <div className="text-white text-3xl w-full flex justify-between items-center p-4">
                <div className="flex items-center gap-6">
                  <h1 className="text-2xl font-bold text-white">
                    Score: {score}
                  </h1>
                  <h1 className="text-2xl font-bold text-white">
                    Lives: {renderHearts()}
                  </h1>
                </div>

                <div className="flex items-center gap-4">
                  <button
                    className="group relative inline-flex items-center px-6 py-3 bg-[var(--interactive-color)] text-white rounded-lg text-xl font-bold transform transition-all duration-300 hover:bg-opacity-90 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[var(--interactive-color)] focus:ring-offset-2 focus:ring-offset-[var(--background-color)]"
                    onClick={resetGame}
                  >
                    <MdOutlineRestartAlt className="mr-2 text-xl" />
                    Restart
                  </button>

                  <button
                    className="group relative inline-flex items-center px-6 py-3 bg-[var(--error-color)] text-white rounded-lg text-xl font-bold transform transition-all duration-300 hover:bg-opacity-90 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[var(--error-color)] focus:ring-offset-2 focus:ring-offset-[var(--background-color)]"
                    onClick={exitGame}
                  >
                    Exit
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="p-6">
            <div className="bg-black rounded-2xl shadow-lg overflow-hidden border border-[var(--border-color)] p-6">
              <canvas
                ref={canvasRef}
                width={800}
                height={600}
                className="w-full h-full"
              />
            </div>
          </div>
        </div>

        {/* Game Over Screen */}
        {gameOver && (
          <GameOverScreen
            score={score}
            onRestart={resetGame}
            onExit={exitGame}
          />
        )}

        {/* Popup */}
        {showPopup && (
          <Popup
            onClose={handleClosePopup}
            score={score}
            setScore={setScore}
            lives={lives}
            setLives={setLives}
            useLives={true}
            gameOver={gameOver}
          />
        )}
      </div>
    </div>
  );
}

export default Game;
